module.exports = __webpack_public_path__ + "img/grading_fail.eac8a367.png";